const ALLOWED_PROTOCOLS = new Set(["http:", "https:"]);

export const normalizeHttpUrl = (value) => {
  if (!value) {
    return "";
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return "";
  }

  try {
    const url = new URL(trimmed);
    return ALLOWED_PROTOCOLS.has(url.protocol) ? url.toString() : "";
  } catch {
    return "";
  }
};

export const isSafeHttpUrl = (value) => {
  if (!value) {
    return true;
  }
  return normalizeHttpUrl(value) !== "";
};
